module.exports = "<div class=\"spline\"></div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/charts/spline.html
// module id = 629
// module chunks = 0